import React, { useState } from 'react';
import { SectionHeader } from '../components/UI';
import { MODULES, BONUS_MODULES } from '../data/courseData';
import styles from './Curriculum.module.css';

export default function Curriculum() {
  const [openId, setOpenId] = useState(1);

  return (
    <section className={styles.section} id="curriculum">
      <div className={styles.container}>
        <SectionHeader
          label="Full Curriculum"
          title="A practical, structured path — week by week"
          subtitle="No filler modules. Every topic directly maps to a skill you'll use in the real world."
          center
        />

        <div className={styles.modules}>
          {MODULES.map((mod) => {
            const isOpen = openId === mod.id;
            return (
              <div
                key={mod.id}
                className={`${styles.module} ${isOpen ? styles.open : ''}`}
              >
                <button
                  className={styles.header}
                  onClick={() => setOpenId(isOpen ? null : mod.id)}
                  aria-expanded={isOpen}
                >
                  <div className={styles.left}>
                    <span className={styles.num}>{String(mod.id).padStart(2, '0')}</span>
                    <div>
                      <div className={styles.title}>{mod.title}</div>
                      <div className={styles.week}>{mod.week}</div>
                    </div>
                  </div>
                  <span className={`${styles.arrow} ${isOpen ? styles.arrowOpen : ''}`}>
                    ↓
                  </span>
                </button>

                <div className={`${styles.body} ${isOpen ? styles.bodyOpen : ''}`}>
                  <ul className={styles.topics}>
                    {mod.topics.map((t, i) => (
                      <li key={i} className={styles.topic}>
                        <span className={styles.check}>✓</span>
                        {t}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

       
      </div>
    </section>
  );
}
